import { render, staticRenderFns } from "./TaskAssigneesModal.vue?vue&type=template&id=05288328&"
import script from "./TaskAssigneesModal.vue?vue&type=script&lang=js&"
export * from "./TaskAssigneesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports